/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trial_Upgrade_TooltipInputs */

const en_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are currently using a free trial subscription. Upgrades are not available during the trial period.`)
};

const id_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda saat ini menggunakan langganan uji coba gratis. Peningkatan tidak tersedia selama periode uji coba.`)
};

const ms_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sedang menggunakan langganan percubaan percuma. Peningkatan tidak tersedia semasa tempoh percubaan.`)
};

const ca_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualment estàs utilitzant una subscripció gratuïta de prova. No hi ha disponibles actualitzacions durant el període de prova.`)
};

const cs_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuálně používáte zkušební předplatné zdarma. Upgrady během zkušebního období nejsou dostupné.`)
};

const da_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bruger i øjeblikket et gratis prøveabonnement. Opgraderinger er ikke tilgængelige i prøveperioden.`)
};

const de_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie verwenden derzeit ein kostenloses Testabonnement. Upgrades sind während der Testphase nicht verfügbar.`)
};

const et_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasutate praegu tasuta prooviperioodi tellimust. Uuendusi ei ole võimalik prooviperioodi ajal teha.`)
};

const es_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualmente estás usando una suscripción de prueba gratuita. No están disponibles las mejoras durante el período de prueba.`)
};

const fr_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous bénéficiez actuellement de l’essai gratuit. Les mises à niveau ne sont pas disponibles pendant la période d’essai.`)
};

const hr_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutačno koristite besplatnu probnu pretplatu. Nadogradnje nisu dostupne tijekom probnog razdoblja.`)
};

const it_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai usando un abbonamento in prova gratuita. Gli upgrade non sono disponibili durante il periodo di prova.`)
};

const lv_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pašlaik izmantojat bezmaksas izmēģinājuma abonementu. Jauninājumi nav pieejami izmēģinājuma perioda laikā.`)
};

const lt_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šiuo metu naudojate nemokamą bandomąją prenumeratą. Atnaujinimai nepasiekiami bandomuoju laikotarpiu.`)
};

const hu_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelenleg egy ingyenes próbaverziós előfizetést használ. Frissítések nem érhetők el a próbaverzió alatt.`)
};

const nl_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je gebruikt momenteel een proefabonnement. Upgrades zijn niet beschikbaar tijdens de proefperiode.`)
};

const nb_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bruker for øyeblikket et gratis prøveabonnement. Oppgraderinger er ikke tilgjengelige i prøveperioden.`)
};

const pl_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecnie korzystasz z subskrypcji próbnej. Ulepszenia nie są dostępne w okresie próbnym.`)
};

const pt_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está usando uma assinatura de teste gratuito no momento. Atualizações não estão disponíveis durante o período de teste.`)
};

const ro_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În prezent folosiți un abonament de probă gratuit. Upgrade-urile nu sunt disponibile în perioada de probă.`)
};

const sk_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V súčasnosti používate bezplatnú skúšobnú verziu predplatného. Upgrady nie sú dostupné počas skúšobného obdobia.`)
};

const sl_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenutno uporabljate brezplačno preizkusno naročnino. Nadgradnje niso na voljo v času preizkusnega obdobja.`)
};

const fi_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytät tällä hetkellä ilmaista kokeilutilausta. Päivitykset eivät ole saatavilla kokeilujakson aikana.`)
};

const sv_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du använder för närvarande ett gratis provabonnemang. Uppgraderingar är inte tillgängliga under provperioden.`)
};

const vi_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đang sử dụng gói đăng ký thử nghiệm miễn phí hiện tại. Nâng cấp không khả dụng trong thời gian thử nghiệm.`)
};

const tr_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda ücretsiz deneme aboneliği kullanıyorsunuz. Deneme süresi boyunca yükseltmeler mevcut değildir.`)
};

const el_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χρησιμοποιείτε αυτή τη στιγμή συνδρομή σε δωρεάν δοκιμαστική περίοδο. Οι αναβαθμίσεις δεν είναι διαθέσιμες κατά τη διάρκεια της δοκιμαστικής περιόδου.`)
};

const bg_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В момента използвате безплатен пробен абонамент. Надстройките не са налични по време на пробния период.`)
};

const ru_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В данный момент вы используете пробную подписку. Обновления недоступны в течение пробного периода.`)
};

const sr_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренутно користите бесплатну пробну претплату. Унапређења нису доступна током пробног периода.`)
};

const uk_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наразі ви використовуєте пробну підписку. Оновлення недоступні під час пробного періоду.`)
};

const ka_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ამჟამად გამოიყენება უფასო ცდის გამოწერა. განახლებები არ არის ხელმისაწვდომი ამ ცდის პერიოდში.`)
};

const hi_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप वर्तमान में नि: शुल्क परीक्षण सदस्यता का उपयोग कर रहे हैं। परीक्षण अवधि के दौरान अपग्रेड उपलब्ध नहीं हैं।`)
};

const th_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกำลังใช้การสมัครทดลองใช้งานฟรี การอัปเกรดไม่สามารถใช้ได้ในระหว่างช่วงทดลองใช้งาน`)
};

const ko_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 무료 체험 구독을 사용 중입니다. 체험 기간 동안에는 업그레이드를 진행할 수 없습니다.`)
};

const zh_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您目前正在使用免费试用订阅。试用期间无法升级。`)
};

const zh_tw_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您目前正在使用免費試用訂閱服務。試用期間無法進行升級。`)
};

const ja_trial_upgrade_tooltip = /** @type {(inputs: Trial_Upgrade_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在、無料トライアルサブスクリプションを使用しています。トライアル期間中はアップグレードできません。`)
};

/**
* | output |
* | --- |
* | "You are currently using a free trial subscription. Upgrades are not available during the trial period." |
*
* @param {Trial_Upgrade_TooltipInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const trial_upgrade_tooltip = /** @type {((inputs?: Trial_Upgrade_TooltipInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trial_Upgrade_TooltipInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_trial_upgrade_tooltip(inputs)
	if (locale === "ms") return ms_trial_upgrade_tooltip(inputs)
	if (locale === "ca") return ca_trial_upgrade_tooltip(inputs)
	if (locale === "cs") return cs_trial_upgrade_tooltip(inputs)
	if (locale === "da") return da_trial_upgrade_tooltip(inputs)
	if (locale === "de") return de_trial_upgrade_tooltip(inputs)
	if (locale === "et") return et_trial_upgrade_tooltip(inputs)
	if (locale === "es") return es_trial_upgrade_tooltip(inputs)
	if (locale === "fr") return fr_trial_upgrade_tooltip(inputs)
	if (locale === "hr") return hr_trial_upgrade_tooltip(inputs)
	if (locale === "it") return it_trial_upgrade_tooltip(inputs)
	if (locale === "lv") return lv_trial_upgrade_tooltip(inputs)
	if (locale === "lt") return lt_trial_upgrade_tooltip(inputs)
	if (locale === "hu") return hu_trial_upgrade_tooltip(inputs)
	if (locale === "nl") return nl_trial_upgrade_tooltip(inputs)
	if (locale === "nb") return nb_trial_upgrade_tooltip(inputs)
	if (locale === "pl") return pl_trial_upgrade_tooltip(inputs)
	if (locale === "pt") return pt_trial_upgrade_tooltip(inputs)
	if (locale === "ro") return ro_trial_upgrade_tooltip(inputs)
	if (locale === "sk") return sk_trial_upgrade_tooltip(inputs)
	if (locale === "sl") return sl_trial_upgrade_tooltip(inputs)
	if (locale === "fi") return fi_trial_upgrade_tooltip(inputs)
	if (locale === "sv") return sv_trial_upgrade_tooltip(inputs)
	if (locale === "vi") return vi_trial_upgrade_tooltip(inputs)
	if (locale === "tr") return tr_trial_upgrade_tooltip(inputs)
	if (locale === "el") return el_trial_upgrade_tooltip(inputs)
	if (locale === "bg") return bg_trial_upgrade_tooltip(inputs)
	if (locale === "ru") return ru_trial_upgrade_tooltip(inputs)
	if (locale === "sr") return sr_trial_upgrade_tooltip(inputs)
	if (locale === "uk") return uk_trial_upgrade_tooltip(inputs)
	if (locale === "ka") return ka_trial_upgrade_tooltip(inputs)
	if (locale === "hi") return hi_trial_upgrade_tooltip(inputs)
	if (locale === "th") return th_trial_upgrade_tooltip(inputs)
	if (locale === "ko") return ko_trial_upgrade_tooltip(inputs)
	if (locale === "zh") return zh_trial_upgrade_tooltip(inputs)
	if (locale === "zh-tw") return zh_tw_trial_upgrade_tooltip(inputs)
	if (locale === "ja") return ja_trial_upgrade_tooltip(inputs)
	return en_trial_upgrade_tooltip(inputs)
});